"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react');



var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _utils = require('../utils');








/* New chat opens over the chat that is open, without changing the route, so
 * that chat stays selected and open under it. Closing it leaves you there;
 * only opening or creating a chat from it navigates. */
const useCreateNewChat = ({ createdChatTypeURLToken, blobjectKey }) => {
  const currentCreatedChatType = _utils.mapURLTokenToChatType.call(void 0, createdChatTypeURLToken)
  const [createdChatType, setCreatedChatType] =
    _react.useState(currentCreatedChatType)
  // Showing, or put away (and kept, with its draft row) while another chat
  // is opened from the list.
  const [isOpen, setIsOpen] = _react.useState.call(void 0, !!currentCreatedChatType)
  // Its draft one-to-one or patient chat is in the right pane.
  const [isDraft, setIsDraft] = _react.useState.call(void 0, false)

  _react.useEffect.call(void 0, 
    () => {
      if (!currentCreatedChatType) return
      setCreatedChatType(currentCreatedChatType)
      setIsOpen(true)
    },
    [currentCreatedChatType],
  )

  // Opening another chat from the list puts New chat away.
  const openedKeyRef = _react.useRef.call(void 0, blobjectKey)
  _react.useEffect.call(void 0, 
    () => {
      if (openedKeyRef.current === blobjectKey) return
      openedKeyRef.current = blobjectKey
      setIsOpen(false)
    },
    [blobjectKey],
  )

  // "+" while New chat (or its draft) is showing starts it over.
  const [newChatRun, setNewChatRun] = _react.useState.call(void 0, 0)
  const onCreateNewChat = _react.useCallback.call(void 0, (type) => {
    if (isOpen) setNewChatRun(run => run + 1)
    setCreatedChatType(type)
    setIsOpen(true)
  }, [isOpen])

  // The draft row brings it back as it was.
  const onReopenNewChat = _react.useCallback.call(void 0, () => setIsOpen(true), [])

  const reset = _react.useCallback.call(void 0, () => {
    setCreatedChatType(null)
    setIsOpen(false)
    setIsDraft(false)
  }, [])

  const onCloseCreateNewChat = _react.useCallback.call(void 0, 
    () => {
      reset()
      if (currentCreatedChatType) _actions2.default.gotoInbox()
    },
    [currentCreatedChatType, reset],
  )

  // A chat was opened or created from the compose: the draft row goes, and
  // the route has already moved to that chat.
  const onCreatedChat = reset

  return {
    createdChatType,
    isNewChatOpen: !!createdChatType && isOpen,
    isDraftOpen: !!createdChatType && isOpen && isDraft,
    newChatRun,
    onCreateNewChat,
    onReopenNewChat,
    onCloseCreateNewChat,
    onCreatedChat,
    onDraftChange: setIsDraft,
  }
}

exports. default = useCreateNewChat
